// Phase 44.12 — Card "Credito DapNow" per il profilo cliente.
// Mostra il `credit_balance_chf` del wallet utente (referral CHF 5 + future
// estensioni). Sempre renderizzata: positive balance → highlight emerald,
// zero balance ma referral pending → tone informativo (pronto a ricevere),
// nessun referral → tone neutro grigio (info statica).
import { Sparkles, Gift } from "lucide-react";
import { formatCHF } from "@/lib/format";

export default function CustomerCreditCard({ user }) {
  if (!user) return null;
  const balance = Number(user.credit_balance_chf || 0);
  const rr = user.recipient_referral || null;
  const referralPending = Boolean(rr) && !rr.granted;
  const hasBalance = balance > 0.001;

  // Variant 1 — credito disponibile (caso positivo)
  if (hasBalance) {
    return (
      <section
        className="relative overflow-hidden rounded-2xl border border-emerald-200 bg-white shadow-sm p-5 sm:p-6"
        data-testid="customer-credit-card"
      >
        <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-emerald-100/70 blur-3xl" aria-hidden="true" />
        <div className="relative flex items-start gap-4">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700 shrink-0">
            <Sparkles className="h-6 w-6" />
          </span>
          <div className="flex-1 min-w-0">
            <p className="overline text-emerald-700">Credito DapNow</p>
            <p
              className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-dapnow-ink mt-0.5"
              data-testid="customer-credit-balance"
            >
              {formatCHF(balance)}
            </p>
            <p className="text-xs text-dapnow-muted mt-2 leading-relaxed">
              Saldo wallet disponibile. Verrà usato automaticamente al prossimo ordine.
            </p>
          </div>
        </div>
      </section>
    );
  }

  // Variant 2 — referral attivo ma non ancora consegnato il primo ordine
  if (referralPending) {
    const amount = Number(rr.credit_amount_chf || 5);
    return (
      <section
        className="rounded-2xl border border-dapnow-line bg-white shadow-sm p-5 sm:p-6"
        data-testid="customer-credit-card-pending"
      >
        <div className="flex items-start gap-4">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-dapnow-blue-soft text-dapnow-blue shrink-0">
            <Gift className="h-6 w-6" />
          </span>
          <div className="flex-1 min-w-0">
            <p className="overline text-dapnow-blue">Credito DapNow in arrivo</p>
            <p className="font-display text-xl font-bold tracking-tight text-dapnow-ink mt-0.5">
              {formatCHF(amount)} al primo ordine consegnato
            </p>
            <p className="text-xs text-dapnow-muted mt-2 leading-relaxed">
              Il tuo credito di benvenuto sarà accreditato automaticamente quando completerai la tua prima consegna con DapNow.
            </p>
          </div>
        </div>
      </section>
    );
  }

  // Variant 3 — nessun credito, nessun referral: non renderizziamo (no rumore)
  return null;
}
